// extracted by mini-css-extract-plugin
module.exports = {"root":"_ed57c6","amount":"_906079","number":"_88b1c6","tag":"_4635be","tags":"_c71c1e"};